import { Flex } from "@mantine/core";
import { type UseFieldArrayReturn } from "react-hook-form";
import { type IPositioningForm } from "src/pages/Settings/YachtSetup/DynamicPositioningSetup/DynamicPositioningSetup.types";

import PositioningItem from "./PositioningItem";

type Props = Omit<UseFieldArrayReturn<IPositioningForm>, "append">;

const PositioningList = ({ fields, remove }: Props) => {
  return (
    <Flex w="100%" direction="column" align="center" mt="md">
      {fields.map((item, index) => (
        <PositioningItem
          key={item.id}
          id={`list.${index}`}
          remove={() => remove(index)}
          disabled={item.disabled}
        />
      ))}
    </Flex>
  );
};

export default PositioningList;
